import {AsyncStatus} from 'enums';
import {IStats, IStatsAPI} from 'interfaces';
import {axiosAPI} from './API';
import {DateTime} from 'luxon';
import {formatDateDt} from './Utils';

class _StatsService {

    private loadPromise: Promise<IStats>;
    private loadStatus = AsyncStatus.Initial;

    public stats: IStats = {};

    public getStats(): Promise<IStats> {
        if (!this.loadPromise || this.loadStatus === AsyncStatus.Error) {

            this.loadStatus = AsyncStatus.Loading;
            this.loadPromise = axiosAPI.get<IStatsAPI>('/stats/ops')
                .then((response) => {
                    this.loadStatus = AsyncStatus.Success;
                    this.stats = response.data.data;
                    this.convertDateTimes();
                    return this.stats;
                });
            this.loadPromise.catch((err) => {
                this.loadStatus = AsyncStatus.Error;
                console.error('Error getting stats: ', err);
            });
        }
        return this.loadPromise;
    }

    // Iterate through stats object and reformat iso datetime
    private convertDateTimes() {
        let k: keyof IStats;
        for (k in this.stats) {
            if (k === "mqttIsConnected") continue;
            this.stats[k] = new Date(this.stats[k]).toLocaleString();
        }
    }

}

export const StatsService = new _StatsService();